<template>
  <v-snackbar
    v-model="showToast"
    :timeout="timeout"
    :color="toastColor"
    top
    right
    multi-line
    vertical
    :value="true"
    class="integration-health-toast"
  >
    <div class="d-flex align-start">
      <v-icon class="mr-3 mt-1">{{ toastIcon }}</v-icon>
      <div class="flex-grow-1">
        <div class="font-weight-bold mb-1">
          {{ toastTitle }}
        </div>
        <div class="text-body-2">
          {{ toastMessage }}
        </div>
      </div>
    </div>
    
    <template v-slot:action="{ attrs }">
      <v-btn
        text
        small
        v-bind="attrs"
        @click="handleAction"
      >
        {{ actionText }}
      </v-btn>
      <v-btn
        icon
        small
        v-bind="attrs"
        @click="showToast = false"
      >
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </template>
  </v-snackbar>
</template>

<script>
// No imports needed for actions since we removed retry functionality

export default {
  name: 'IntegrationHealthToast',
  
  props: {
    integration: {
      type: Object,
      required: true,
    },
    show: {
      type: Boolean,
      default: false,
    },
    timeout: {
      type: Number,
      default: 8000, // 8 seconds
    },
  },

  data() {
    return {
      showToast: false,
    };
  },

  computed: {
    toastColor() {
      switch (this.integration?.health?.status) {
        case 'error':
          return 'error';
        case 'warning':
          return 'warning';
        default:
          return 'info';
      }
    },

    toastIcon() {
      switch (this.integration?.health?.status) {
        case 'error':
          return 'mdi-alert-circle-outline';
        case 'warning':
          return 'mdi-alert-outline';
        default:
          return 'mdi-information-outline';
      }
    },

    toastTitle() {
      if (!this.integration) return '';
      
      switch (this.integration.health?.status) {
        case 'error':
          return `${this.integration.integrationName} Connection Lost`;
        case 'warning':
          return `${this.integration.integrationName} Issue Detected`;
        default:
          return `${this.integration.integrationName} Notification`;
      }
    },

    toastMessage() {
      if (!this.integration?.health) return '';
      
      const health = this.integration.health;
      
      if (health.errorMessage) {
        return health.errorMessage;
      }
      
      switch (health.status) {
        case 'error':
          return 'Your integration is experiencing connection issues. Data synchronization may be affected.';
        case 'warning':
          return 'Some issues detected that may affect integration performance.';
        default:
          return 'Integration status update available.';
      }
    },

    actionText() {
      return 'View Details';
    },
  },

  watch: {
    show(newVal) {
      this.showToast = newVal;
    },
  },

  methods: {
    async handleAction() {
      this.viewDetails();
      this.showToast = false;
    },

    viewDetails() {
      this.$emit('view-details', this.integration);
    },
  },

  mounted() {
    this.showToast = this.show;
  },
};
</script>

<style lang="scss" scoped>
.integration-health-toast {
  ::v-deep .v-snack__wrapper {
    min-width: 350px;
    max-width: 500px;
  }
  
  ::v-deep .v-snack__content {
    padding: 16px;
  }
}

.text-body-2 {
  line-height: 1.4;
  opacity: 0.9;
}
</style> 